import { PointsMaterial, MeshBasicMaterial, LineBasicMaterial, DoubleSide } from 'three';

export function createPointsMaterial(size: number): PointsMaterial {
  return new PointsMaterial({
    vertexColors: true,
    size,
    sizeAttenuation: true,
  });
}

export function createCuboidFaceMaterial(): MeshBasicMaterial {
  return new MeshBasicMaterial({
    transparent: true,
    opacity: 0.3,
    side: DoubleSide,
    depthWrite: false,
  });
}

export function createCuboidEdgeMaterial(): LineBasicMaterial {
  return new LineBasicMaterial({
    color: 0xffffff,
  });
}
